import React, { useEffect, useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { Row, Col, Form, Modal } from "react-bootstrap";
import Footer from "./footer";
import Header from "./header";
import { Link } from "react-router-dom";
import moment from "moment";
import { listAllClassAttendance, stuclasslist } from "../service/dashboard";
import { toast } from "react-toastify";

const StudentAttendance = () => {
    const [attendanceData, setAttendanceData] = useState([]);
    const [fdate, setFDate] = useState("");
    const [tdate, setTDate] = useState("");
    const [cclass, setCClass] = useState(0);
    const [clist, setCList] = useState([]);

    useEffect(() => {
        const startDate = moment().startOf("month").format("YYYY-MM-DD");
        const endDate = moment().endOf("month").format("YYYY-MM-DD");
        setFDate(startDate);
        setTDate(endDate);

        stuclasslist().then((res) => {
            if (res.status === true) {
                let arr = [];
                if (res.data.length > 0) {
                    for (let i = 0; i < res.data.length; i++) {
                        arr.push({
                            value: res.data[i].id,
                            label: res.data[i].class_name,
                        });
                    }
                    setCList(arr);
                }
            }
        });

        fetchAttendance(startDate, endDate, 0);

    }, []);
    const fetchAttendance = (startDate, endDate, lcls) => {
        setFDate(startDate);
        setTDate(endDate);
        setCClass(lcls);
        listAllClassAttendance(startDate, endDate, lcls, localStorage.getItem("academy"), 4).then((res) => {
            if (res.status === true) {
                const transformedData = res.data.map(item => {
                    const morningStatus = item.TimeStatus.find(t => t.Time === 'Morning') || {};
                    const afternoonStatus = item.TimeStatus.find(t => t.Time === 'Afternoon') || {};

                    return {
                        academic_year: item.academic_year,
                        att_date: moment(item.date).format("DD-MM-YYYY"),
                        class_name: item.class_name,
                        section_name: item.section_name,
                        academy_name: item.academy_name,
                        total_students: item.total_students,
                        morning_present: morningStatus.present_count || 0,
                        morning_absent: morningStatus.absent_count || 0,
                        afternoon_present: afternoonStatus.present_count || 0,
                        afternoon_absent: afternoonStatus.absent_count || 0,
                        all_list: item.AllList
                    };
                });
                setAttendanceData(transformedData);

            } else {
                toast.error(res.message);
            }
        });
    };

    const [show, setShow] = useState(false);
    const [alldata, setAlldata] = useState([]);
    function viewreport(rdata) {
        if (rdata.all_list.length > 0) {
            rdata.all_list = rdata.all_list.map((item) => {
                return {
                    ...item,
                    // attendance_date: moment(item.attendance_date).format("DD-MM-YYYY"),
                    morning_status:
                        item.morning_status === 1
                            ? "Present"
                            : item.morning_status === 0
                                ? "Absent"
                                : "",
                    evening_status:
                        item.evening_status === 1
                            ? "Present"
                            : item.evening_status === 0
                                ? "Absent"
                                : ""
                };
            });
        }
        setAlldata(rdata.all_list);
        setShow(true);
    }


    return (
        <div id="mainpage">
            <div className="maincontent">
                <Header />
                <div className="moreheading">
                    <Row className="row-sm">

                        {localStorage.getItem("Role") == "5" ? (
                            <>
                                <Col xs={4} className="text-left align-self-end">
                                    <h4 className="morehead-text">Student Attendance</h4>
                                </Col>
                                <Col xs={4} className="text-right align-self-end">
                                    <Link to={"/addattendance"} className="btn-outline-success green-btn btn-sm">
                                        <i className="fa-solid fa fa-plus-square"></i> Add
                                    </Link>
                                </Col>
                            </>
                        ) : <Col xs={8} className="text-left align-self-end">
                            <h4 className="morehead-text">My Attendance</h4>
                        </Col>
                        }

                        <Col xs={4} className="text-right align-self-end">
                            <Link to={"/dashboard"} className="btn-outline-success red-btn btn-sm">
                                <i className="fa-solid fa-hand-point-left"></i> Go Back
                            </Link>
                        </Col>

                    </Row>
                </div>


                <div className="mb-4">
                    <Col xxl={3} lg={3} md={3}>
                        <label className="form-label">From Date</label>
                        <input
                            type="date"
                            className="form-control"
                            value={fdate}
                            onChange={(e) => fetchAttendance(e.target.value, tdate, cclass)}
                        />
                    </Col>
                    <Col xxl={3} lg={3} md={3}>
                        <label className="form-label">To Date</label>
                        <input
                            type="date"
                            className="form-control"
                            value={tdate}
                            onChange={(e) => fetchAttendance(fdate, e.target.value, cclass)}
                        />
                    </Col>
                    <Col xxl={3} lg={3} md={3}>
                        <label className="form-label">Filter by Class</label>
                        <select
                            className="form-control"
                            onChange={(e) => fetchAttendance(fdate, tdate, e.target.value)}
                            value={cclass}
                        >
                            <option value={0} disabled>
                                Select Class
                            </option>
                            {clist.map((classItem, i) => (
                                <option value={classItem.value} key={i}>
                                    {classItem.label}
                                </option>
                            ))}
                        </select>
                    </Col>
                    <table className="table table-bordered align-middle text-center mt-2">
                        <thead className="table-light table-head-color">
                            <tr>
                                <th>Actions</th>
                                <th>Academic Year</th>
                                <th>Date</th>
                                <th>Class</th>
                                <th>Section</th>
                                {/* <th>Total</th>
                                <th>Morning Present</th>
                                <th>Morning Absent</th>
                                <th>Evening Present</th>
                                <th>Evening Absent</th> */}

                            </tr>
                        </thead>
                        <tbody>
                            {attendanceData.map(student => (
                                <tr key={student.id}>
                                    <td>
                                        <a
                                            title="View Attendance List"
                                            onClick={() => viewreport(student)}
                                            className="btn-sm btn-secondary"
                                        >
                                            <i className="fa fa-list"></i>
                                        </a>
                                    </td>
                                    <td>{student.academic_year}</td>
                                    <td>{student.att_date}</td>
                                    <td>{student.class_name}</td>
                                    <td>{student.section_name}</td>
                                    {/* <td>{student.total_students}</td>
                                    <td>{student.morning_present}</td>
                                    <td>{student.morning_absent}</td>
                                    <td>{student.evening_present}</td>
                                    <td>{student.evening_absent}</td> */}


                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <Modal size="lg" show={show}>
                        <Modal.Header>
                            <h4>
                                <span>Attendance List</span>
                            </h4>
                        </Modal.Header>
                        <Modal.Body>

                            <table className="table table-bordered align-middle text-center">
                                <thead className="table-light table-head-color">
                                    <tr>
                                        <th>Name</th>
                                        <th>Date</th>
                                        <th>Morning</th>
                                        <th>Evening</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {alldata.map(student => (
                                        <tr key={student.id}>

                                            <td>{student.student_name}</td>
                                            <td>{moment(student.attendance_date).format("DD-MM-YYYY")}</td>
                                            <td>{student.morning_status}</td>
                                            <td>{student.evening_status}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                          
                        </Modal.Body>
                        <Modal.Footer>
                            <a
                                className="btn btn-next btn-secondary"
                                style={{ float: "right" }}
                                onClick={() => setShow(false)}
                            >
                                Close
                            </a>
                        </Modal.Footer>
                    </Modal>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default StudentAttendance;
